import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import logo from '../../../images/logo.png'
import {Link} from 'react-router-dom'
import api from '../../../source/api'
import User from '../../../helpers/user'
import Actions from "../../../actions/actions";

export default class Header extends Reflux.Component {

    constructor(props) {
        super(props)
        this.store = Store
    }

    componentDidMount = () => {
        if (!User.isGuest()) {
            api.get('user/getbalance')
                .then((response) => {
                    Actions.userBalanceSet(response.data.balance)
                })
        }
    }


    render() {
        return (
            <section id='header'>
                <nav className='navbar navbar-expand-lg'>
                    <div className='container'>
                        <Link className='navbar-brand' to='/'>
                            <img className='header-logo img-fluid' src={logo} title='logo' alt='logo'/>
                        </Link>
                        <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
                            <span className='navbar-toggler-icon'></span>
                        </button>

                        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                            <ul className='navbar-nav ml-auto'>
                                {User.isGuest()
                                    ? <React.Fragment>
                                        <li className='nav-item'>
                                            <Link className='nav-link' to='/login'>Bejelentkezés</Link>
                                        </li>
                                        <li className='nav-item'>
                                            <a target='_blank' className='nav-link' href='https://beeker.hu/'>Mi is az a Beeker?</a>
                                        </li>
                                    </React.Fragment>
                                    : <React.Fragment>
                                        <li className={'nav-item' + (User.showBalance() ? '' : ' d-none')}>
                                            <Link className='nav-link' to='/payment-start'>Egyenleg feltöltés</Link>
                                        </li>
                                        <li className={'nav-item balance-info' + (User.isTestMode() ? '' : ' d-none')}>
                                            Teszt üzemmód lejárata: {User.testModeExpiration()}
                                        </li>
                                        <li className='nav-item'>
                                            <Link className='nav-link' to={'/user-profile'}>Profil</Link>
                                        </li>
                                        <li className='nav-item'>
                                            <a className='nav-link' onClick={() => User.logout()}>Kijelentkezés</a>
                                        </li>
                                    </React.Fragment>
                                }
                            </ul>
                        </div>
                    </div>
                </nav>
            </section>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/common/header/header.js